<template>
  <section class="sonar-lab-image__container">
    <img class="sonar-lab-image__img" :src="imageURL" />
  </section>
</template>

<script>
export default {
  name: 'SonarImage',
  props: {
    imageURL: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.sonar-lab-image {
  width: 100%;
  height: 100%;
  min-height: 280px;
  border-top: 1px solid var(--tundora-gray);
  &__container {
    width: 100%;
    height: 100%;
  }
  &__img {
    width: 100%;
    height: 100%;
    border-radius: 10px;
    object-fit: contain;
  }
}
</style>
